import { Button, Center, HTMLChakraProps, RecipeKey, RecipeVariantProps, Text, useRecipe } from '@chakra-ui/react';
import { buttonRecipe } from '@theme/recipes/button.recipe';
import { forwardRef, ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

type ButtonVariantProps = HTMLChakraProps<'button'> & RecipeVariantProps<typeof buttonRecipe>;

interface ButtonWithIconProps extends ButtonVariantProps {
  label: string;
  icon?: ReactNode;
  loading?: boolean;
  side?: 'left' | 'right';
}
export const ButtonWithIcon = forwardRef<HTMLButtonElement, ButtonWithIconProps>(
  ({ label, icon, side = 'left', variant = 'toggle', size = 'toggleM', ...props }, ref) => {
    const recipe = useRecipe({ key: variant as RecipeKey });
    const [variantProps, rest] = recipe.splitVariantProps(props as ButtonWithIconProps);
    const styles = recipe(variantProps);

    return (
      <Button
        ref={ref}
        css={styles}
        addon="icon"
        {...rest}
        gap={1.5}
        paddingX={1.5}
        variant={variant}
        size={size}
        overflow="hidden"
      >
        {icon && side === 'left' && (
          <Center data-part="iconBox" backgroundColor="transparent">
            {icon}
          </Center>
        )}
        <Text data-part="labelBox">
          <FormattedMessage id={label} />
        </Text>
        {icon && side === 'right' && <Center data-part="iconBox">{icon}</Center>}
      </Button>
    );
  },
);
